/* @flow */

import { makeListLink } from './utils';

export default makeListLink({
  pathname: '/annotations',
  children: 'annotations',
});



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/AnnotationsLink.js